import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { GameService } from '../services/game.service';

@Injectable()
export class LevelGuard implements CanActivate, CanActivateChild {
    constructor(public game: GameService, public router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        const levelId = +route.params['id'];
        // Redirect illegal level id's to dashboard
        if (isNaN(levelId) || levelId < 0 || levelId > 8) {
            console.error('Navigate to dashboard, invalid level:', levelId);
            this.router.navigate(['/dashboard']);
            return false;
        }

        const allowed = this.game.getLevelOpenStatus(levelId);
        if (!allowed) {
            console.error('Level mag nog niet geopend worden!');
            this.router.navigate(['/dashboard']);
            return false;
        }
        return allowed;
    }


    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.canActivate(childRoute, state);
    }
}
